import './index.scss'
import React from 'react'
import SideBar from '../SideBar'
import { Outlet } from 'react-router-dom'

const Layout = () => {
  return (
    <div className="App">
      <SideBar />
      <div className="page">
        <span className="tags top-tags">&lt;body&gt; </span>

        <Outlet />

        <span className="tags bottom-tags">
          &lt;body&gt;
          <span className="bottom-tag-html">&lt;/html&gt;</span>
          <br />
        </span>
      </div>
    </div>
  )
}

export default Layout
